import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { triggerRentReminder } from '../Property_Api'
import MarkAsPaid from './Components/MarkAsPaid'
import { rentPaymentListDataType } from './RestInfoDataType'
import InvoiceTypeSubmenu from '../../rentedProperties/Components/InvoiceTypeSubmenu'
import TransactionDetails from './Components/TransactionDetails'
import styles from '../../KYCDetails/KYCDetailsStyles/KYCDetailsStyle.module.scss'

const RentedPropertiesDetailPage = ({
  rentPaymentList,
  getTenantRentPaymentList,
}: any
  // {
  //   rentPaymentList: rentPaymentListDataType[]
  //   getTenantRentPaymentList: (
  //     property_uuid: string,
  //     property_sub_unit_uuid: string,
  //     forceReFetch: boolean
  //   ) => Promise<void>
  // }
) => {
  const [showMarkAsPaid, setShowMarkAsPaid] = useState<string | undefined>()
  const [triggerReminderLoading, setTriggerReminderLoading] = useState<string>('')
  const [showTransactionDtlModal, setShowTransactionDtlModal] = useState<string | undefined>("")
  const [showInvoice, setShowInvoice] = useState<string | null>(null)

  async function triggerRentReminderForTenant(tenant_rent_uuid: string) {
    setTriggerReminderLoading(tenant_rent_uuid)
    try {
      const response = await triggerRentReminder(tenant_rent_uuid)
      if (response.status === 200) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.msg.charAt(0).toUpperCase() + response.data.msg.slice(1),
          text: response.data.msg_details,
          allowOutsideClick: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.data.msg.charAt(0).toUpperCase() + response.data.msg.slice(1),
          text: response.data.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setTriggerReminderLoading('')
    }
  }

  const FormatDate = (date: Date) => {
    const formattedDate = date.toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
    return formattedDate
  }
  const FormatDateMMMYY = (date: Date) => {
    const formattedDate = date.toLocaleDateString('en-CA', {
      year: '2-digit',
      month: 'short',
    })
    return formattedDate
  }
  const handleShowInvoice = (proforma_invoice_link: string, utility_invoice_link: string) => {
    if (showInvoice === proforma_invoice_link) {
      setShowInvoice(null);
    }
    else if (showInvoice === utility_invoice_link) {
      setShowInvoice(null);
    }
    else if (proforma_invoice_link || utility_invoice_link) {
      if (proforma_invoice_link) {
        setShowInvoice(proforma_invoice_link);
      } else if (utility_invoice_link) {
        setShowInvoice(utility_invoice_link);
      } else {
        setShowInvoice(null);
      }
    }
    else {
      setShowInvoice(null);
    }
  };
  return (
    <div id='table div'>
      <div className={`card mb-5 mb-xl-8`}>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              {/* begin::Table head */}
              {rentPaymentList.length > 0 && (
                <thead>
                  <tr className='fw-bold text-muted'>
                    {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div>
                </th> */}
                    <th className='max-w-150px'>Rent Month</th>
                    <th className='max-w-100px'>Rent Amount</th>
                    <th className='max-w-150px'>Rent Due Date</th>
                    <th className='max-w-150px'>Status</th>
                    <th className='max-w-150px'>Actions</th>
                  </tr>
                </thead>
              )}
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {rentPaymentList.length === 0 ? (
                  <tr>
                    <td colSpan={5}>
                      <span className='d-flex flex-column align-items-center flex-start p-10'>
                        <img
                          src='/media/svg/undraw/online_payments.svg'
                          alt='No document uploaded'
                          className='h-200px w-200px'
                        />
                        <span className='fw-bold text-muted fs-1 text-center'>
                          No transactions present
                        </span>
                      </span>
                    </td>
                  </tr>
                ) : (
                  rentPaymentList?.map((payment: any, index: number) => {
                    return (
                      <tr key={index}>
                        <td className='max-w-150px'>
                          <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                            {FormatDateMMMYY(new Date(payment.tenant_rent_due_date))}
                          </div>
                        </td>
                        <td className='max-w-100px'>
                          <span className='text-muted fw-semibold text-muted d-block fs-7'>
                            {`₹ ${payment.tenant_rent_amount}`}
                          </span>
                        </td>
                        <td className='max-w-150px'>
                          <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                            {FormatDate(new Date(payment.tenant_rent_due_date))}
                          </span>
                        </td>
                        <td className='max-w-150px'>
                          <div className='row'>
                            <span className='col-7 pe-0 text-muted fw-semibold text-muted d-block fs-7'>{`Rent Status -`}</span>
                            <div className='col-3'>
                              <span
                                className=
                                {`badge ${payment.tenant_rent_status_name.toLowerCase() === 'pending'
                                  ? 'badge-light-warning'
                                  : payment.tenant_rent_status_name.toLowerCase() === 'processing'
                                    ? `${styles.status_processing}` :
                                    payment.tenant_rent_status_name.toLowerCase() === 'completed'
                                      ? 'badge-light-success' :
                                      payment.tenant_rent_status_name.toLowerCase() === 'failed'
                                        ? 'badge-light-danger' :
                                        payment.tenant_rent_status_name.toLowerCase() === 'overdue'
                                          ? 'badge-light-danger' :
                                          'badge-light-primary'
                                  } fs-8 fw-bold mb-2`}
                              >
                                {payment.tenant_rent_status_name.charAt(0).toUpperCase() + payment.tenant_rent_status_name.slice(1)}
                              </span></div></div>
                          <div className='row'>
                            <span className='col-7 pe-0 text-muted fw-semibold text-muted d-block fs-7'>{`Utility Status -`}</span>
                            <div className='col-3'>
                              <span
                                className={`badge ${payment.tenant_utility_status_name.toLowerCase() === 'pending'
                                  ? 'badge-light-warning'
                                  : payment.tenant_utility_status_name.toLowerCase() === 'processing'
                                    ? `${styles.status_processing}` :
                                    payment.tenant_utility_status_name.toLowerCase() === 'completed'
                                      ? 'badge-light-success' :
                                      payment.tenant_utility_status_name.toLowerCase() === 'failed'
                                        ? 'badge-light-danger' :
                                        payment.tenant_utility_status_name.toLowerCase() === 'overdue'
                                          ? 'badge-light-danger' :
                                          'badge-light-dark'
                                  } fs-8 fw-bold`}
                              >
                                {payment.tenant_utility_status_name ? payment.tenant_utility_status_name.charAt(0).toUpperCase() + payment.tenant_utility_status_name.slice(1) : 'NA'}
                              </span></div>
                          </div>
                        </td>
                        <td className='max-w-150px'>
                          <div className='d-flex flex-shrink-0'>
                            {
                              (payment.proforma_invoice_link || payment.utility_invoice_link) &&
                              <div className='app-navbar-item'>
                                <button
                                  className='position-relative cursor-pointer border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  title='Invoice'
                                  onClick={() => handleShowInvoice(payment.proforma_invoice_link, payment.utility_invoice_link)}
                                >
                                  <i className='bi bi-receipt bi-4x fs-3'></i>
                                </button>
                                <>
                                  {
                                    (showInvoice === (payment.proforma_invoice_link || payment.utility_invoice_link)) &&
                                    <InvoiceTypeSubmenu
                                      utility_invoice_link={payment.utility_invoice_link}
                                      proforma_invoice_link={payment.proforma_invoice_link}
                                      setShowInvoice={setShowInvoice}
                                    />
                                  }
                                </>
                              </div>
                            }
                            {
                              ((payment.proforma_invoice_link &&
                                (payment.tenant_rent_status_name.toLowerCase() !== 'processing' ||
                                  payment.tenant_rent_status_name.toLowerCase() !== 'completed')) ||
                                (payment.utility_invoice_link &&
                                  (payment.tenant_rent_status_name.toLowerCase() !== 'processing' ||
                                    payment.tenant_rent_status_name.toLowerCase() !== 'completed')))
                              &&
                              <div className=''>
                                <button
                                  className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  disabled={triggerReminderLoading ? true : false}
                                  onClick={() =>
                                    triggerRentReminderForTenant(payment.tenant_rent_uuid)
                                  }
                                >
                                  {triggerReminderLoading === payment.tenant_rent_uuid ? (
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                  ) : (
                                    <i className='bi bi-bell fs-3' title='Trigger reminder'></i>
                                  )}
                                </button>
                              </div>
                            }
                            {(payment.tenant_rent_status_name.toLowerCase() !== 'processing' ||
                              payment.tenant_rent_status_name.toLowerCase() !== 'completed' ||
                              payment.tenant_utility_status_name.toLowerCase() !== 'processing' ||
                              payment.tenant_utility_status_name.toLowerCase() !== 'completed') &&
                              <div>
                                <button
                                  className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  onClick={() => setShowMarkAsPaid(payment.tenant_rent_uuid)}
                                >
                                  <i className='bi bi-check-square fs-3' title='Mark as Paid'></i>
                                </button>
                                {showMarkAsPaid === payment.tenant_rent_uuid && (
                                  <MarkAsPaid
                                    rentDetails={payment}
                                    show={true}
                                    handleClose={() => setShowMarkAsPaid(undefined)}
                                    getTenantRentPaymentList={getTenantRentPaymentList}
                                  />
                                )}
                              </div>
                            }
                            {(payment.tenant_rent_status_name.toLowerCase() === 'completed' || payment.tenant_utility_status_name.toLowerCase() === 'completed') &&
                              (
                                <div className=''>
                                  <button type='button'
                                    className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    onClick={() => setShowTransactionDtlModal(payment.tenant_rent_uuid)}>
                                    <i className="bi bi-stickies-fill fs-3" title='Transaction details'></i>
                                  </button>
                                  {showTransactionDtlModal === payment.tenant_rent_uuid &&
                                    < TransactionDetails
                                      show={showTransactionDtlModal}
                                      handleClose={() => setShowTransactionDtlModal(undefined)}
                                      payment={payment}
                                    />
                                  }
                                </div>
                              )}
                          </div>
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RentedPropertiesDetailPage
